module.exports = __webpack_public_path__ + "media/images/facebook-733a0e79a1c8b78fcc38f3f8b81d2496.svg";